import { postFetcher } from './base-api';
import {
  FranchiseReserveRequest,
  FranchiseReserveResponse,
} from './types/franchise.type';

export const postFranchiseReserve = async (body: FranchiseReserveRequest) => {
  return postFetcher<FranchiseReserveResponse, FranchiseReserveRequest>(
    '/consult',
    body,
  );
};
